import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public data : any = {}
  @ViewChild('f') passwordForm : NgForm
  constructor(private http: HttpService) { }

  ngOnInit(): void {
  }

  async submit() {
    const s = await this.http.post('/admin/reset-password', this.data);

    if (s['status']) {
      this.data = {}
      this.passwordForm.resetForm();
    }
  }
}
